<template>
  <div>
    <div>
      <!-- <span slot="label">{{courseTypeText}}</span> -->
      <div>
        <el-row class="cs-filter-row">
          <el-col>
            <el-row>
              <el-col :span="4">
                <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search" v-model.trim="searchPhone" @change="onSearchConditionChanged"
                  @keyup.enter.native="onSearchConditionChanged('', true)"></el-input>
              </el-col>
              <el-col :span="4" v-if="[GLOBAL.courseType.english, GLOBAL.courseType.vocationalTraining, GLOBAL.courseType.newStudentGuide].contains(courseType)">
                <el-select placeholder="业务" v-model="selectedCategory" @change="onCategoryChange" size="medium" class="margin-left-20px">
                  <el-option v-for="item in categoryList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" v-if="courseType == GLOBAL.courseType.university || courseType == GLOBAL.courseType.vocationalTraining">
                <el-select placeholder="类型" v-model="selectedSearchType"
                  @change="onSearchConditionChanged('searchType')" size="medium" class="margin-left-20px">
                  <el-option v-for="item in searchType" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" v-if="
                  (selectedSearchType == 2 || selectedSearchType == 3) &&
                  ([GLOBAL.courseType.university, GLOBAL.courseType.vocationalTraining].contains(courseType))
                ">
                <el-select placeholder="学期" v-model="selectedTermId" @change="onTermChange" size="medium" class="margin-left-20px">
                  <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="8" class="cs-datepick-col" v-if="selectedSearchType == 1 || selectedSearchType == 3">
                <el-date-picker align="center" class="cs-accountList-searchDate" v-model="searchDate" type="daterange" unlink-panels
                  range-separator="-" start-placeholder="开始" end-placeholder="结束" :picker-options="pickerOptions" size="medium"
                  @change="onSearchConditionChanged"></el-date-picker>
              </el-col>
              <el-col :span="selectedSearchType == 3 || courseType != GLOBAL.courseType.university ? 4 : 8" class="cs-saleQuery-buttons">
                <el-button v-if="courseType == GLOBAL.courseType.university && canExportAveragePrice" :loading="isExportingAvgPrice" :disabled="isExporting || isExportingAvgPrice"
                  size="medium" type="primary" @click="onExportAveragePrice()">课程平均价格</el-button>
                <el-button v-if="courseType == GLOBAL.courseType.university && canExport" :loading="isExporting" :disabled="isExporting || isExportingAvgPrice"
                  size="medium" type="primary" @click="onExport()">导出</el-button>
                <el-button size="medium" type="primary" @click="onSearchConditionChanged('', true)">搜索</el-button>
              </el-col>
            </el-row>
            <el-row class="margin-top-10">
              <el-col :span="4">
                <el-select placeholder="大学" v-model="selectedGroupNumber" @change="onSearchConditionChanged('university')" size="medium">
                  <el-option v-for="item in universityGroups" :key="item.GroupNumber" :label="item.NameValue" :value="item.GroupNumber"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select placeholder="所有合同" v-model="selectedContractId" @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option label="所有合同" :value="-1"></el-option>
                  <el-option v-for="item in contractList" :key="item.Id" :label="item.Description" :value="item.Id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select placeholder="所有课程" v-if="courseType == GLOBAL.courseType.university" filterable v-model="selectedCourseCode"
                  @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option v-for="item in courseCodeList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
                <el-select placeholder="所有课程"
                  v-if="[GLOBAL.courseType.english, GLOBAL.courseType.vocationalTraining, GLOBAL.courseType.newStudentGuide].contains(courseType)" filterable
                  v-model="selectedCourseId" @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option v-for="item in trainingCourseList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" v-if="courseType != 4">
                <el-select placeholder="所有老师" filterable v-model="selectedTeacherId" @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option v-for="item in teacherList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" v-if="courseType == GLOBAL.courseType.university">
                <el-select v-model="hasVideoPackage" @change="onSearchConditionChanged" size="medium"
                  class="margin-left-20px">
                  <el-option v-for="item in hasVideoPackageOptions" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" v-if="hasEmployeeFilter">
                <el-select placeholder="请选择" v-model="selectedUserId" @change="onSearchConditionChanged" size="medium" class="margin-left-20px"
                  filterable>
                  <el-option v-for="item in employeeListData" :key="item.Id" :label="item.Name" :value="item.Id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="margin-top-10">
              <el-col :span="4">
                <el-select v-model="selectedAccountStatus" @change="onSearchConditionChanged" size="medium">
                  <el-option v-for="item in accountStatusList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" v-if="courseType != 4">
                <el-select v-model="selectedRefundStatus" @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option v-for="item in refundStatusList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" v-if="courseType != 4">
                <el-select v-model="selectedStudentType" @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option v-for="item in studentTypes" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select v-if="courseType == GLOBAL.courseType.university" v-model="selectedCourseClassGrade" @change="onSearchConditionChanged" size="medium"
                  class="margin-left-20px">
                  <el-option v-for="item in courseClassGradeList" :key="item.Key" :label="item.Value" :value="item.Key">
                  </el-option>
                </el-select>
                <span v-else>&nbsp;</span>
              </el-col>
              <el-col :span="4" v-if="courseType == GLOBAL.courseType.university">
                <el-select v-model="selectedCourseCategoryIds" multiple collapse-tags placeholder="所有课程类型"
                  @change="onCourseCategoryIdsChanged" size="medium" class="margin-left-20px">
                  <el-option :key="0" label="所有课程类型" :value="0"></el-option>
                  <el-option v-for="item in GLOBAL.enumNormalCourseCategory.getOptions()" :key="item.value" :label="item.desc" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select v-if="courseType == GLOBAL.courseType.university" v-model="isStudyAbroad" @change="onSearchConditionChanged" size="medium"
                  class="margin-left-20px">
                  <el-option v-for="item in isStudyAbroadConditionOptions" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
                <span v-else>&nbsp;</span>
              </el-col>
              <el-col :span="4">
                <el-select v-if="courseType == GLOBAL.courseType.university && isStudyAbroad == 2" v-model="studyAbroadBusinessType"
                  @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option :key="-1" label="所有真留业务类型" :value="0" />
                  <el-option v-for="item in GLOBAL.enumBusinessType.getOptions()" :key="item.key" :label="item.desc" :value="item.value" />
                </el-select>
              </el-col> 
            </el-row>
          </el-col>
        </el-row>
        <hr />
        <div v-if="hasSaleSummary" v-loading="isLoadingSaleSummary" class="cs-saleQuery-summary">
          <el-row>
            <el-col :lg="{ span: '4-8' }">
              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  总实时价值收入
                  <el-tooltip class="item" effect="dark" content="实时销售收入+积分抵现+现金减" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  总实时销售收入
                  <el-tooltip class="item" effect="dark" content="当前起始日收入+占位+余额" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewSaleIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewSaleIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  总实时真实收入
                  <el-tooltip class="item" effect="dark" content="实时销售收入 - 实时真实退余额" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount cs-bold">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewRealIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewRealIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  总实时真实入库学费
                  <el-tooltip class="item" effect="dark" content="实时真实收入 - 实时使用余额" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewStorageIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewStorageIncome | toCurrency
                  }}</span>
                </div>
              </div>
            </el-col>

            <el-col :lg="{ span: '4-8' }"  v-if="courseType == GLOBAL.courseType.university">
              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  非VIP实时价值收入
                  <el-tooltip class="item" effect="dark" content="实时销售收入+积分抵现+现金减" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewIncomeWithTax - totalViewVipIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewIncome - totalViewVipIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  非VIP实时销售收入
                  <el-tooltip class="item" effect="dark" content="当前起始日收入+占位+余额" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewSaleIncomeWithTax - totalViewVipSaleIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewSaleIncome - totalViewVipSaleIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  非VIP实时真实收入
                  <el-tooltip class="item" effect="dark" content="实时销售收入 - 实时真实退余额" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount cs-bold">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewNotVipRealIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewNotVipRealIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <!-- <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  非VIP实时真实入库学费
                  <el-tooltip class="item" effect="dark" content="实时真实收入 - 实时使用余额" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewStorageIncomeWithTax - totalViewVipStorageIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewStorageIncome - totalViewVipStorageIncome | toCurrency
                  }}</span>
                </div>
              </div> -->
            </el-col>

            <el-col :lg="{ span: '4-8' }" v-if="courseType == GLOBAL.courseType.university">
              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  VIP实时价值收入
                  <el-tooltip class="item" effect="dark" content="实时销售收入+积分抵现+现金减" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewVipIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewVipIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  VIP实时销售收入
                  <el-tooltip class="item" effect="dark" content="当前起始日收入+占位+余额 (实时真实收入+未消耗+真实退余额)" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewVipSaleIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewVipSaleIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  VIP实时真实收入
                  <el-tooltip class="item" effect="dark" content="VIP已消耗分钟数对应收入" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount cs-bold">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewVipRealIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewVipRealIncome | toCurrency
                  }}</span>
                </div>
              </div>

              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  VIP未消耗
                  <!-- <el-tooltip class="item" effect="dark" content="" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip> -->
                </span>
                <div class="cs-saleQuery-summary-amount cs-bold">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalVIPUnusedWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalVIPUnused | toCurrency
                  }}</span>
                </div>
              </div>
              <!-- <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  VIP实时真实入库学费
                  <el-tooltip class="item" effect="dark" content="实时真实收入 - 实时使用余额" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip>
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount" v-if="canViewTax">(含税){{
                    totalViewVipStorageIncomeWithTax | toCurrency
                  }}</span>
                  <span class="cs-amount">(不含税){{
                    totalViewVipStorageIncome | toCurrency
                  }}</span>
                </div>
              </div> -->
            </el-col>
          </el-row>

          <el-row>
            <el-col :lg="{ span: '4-6' }">
              <div>
                实时报名人数
                <el-tooltip v-if="studentCourseCountData.length > 0 || totalVipCourseStudentCount > 0 || totalRevieCoursewStudentCount > 0" class="item"
                  effect="dark" placement="top">
                  <div slot="content">
                    <span v-for="(item, index) in studentCourseCountData" :key="index">报课{{item.CourseCount}}门:
                      {{item.StudentCount}}人<br /></span>
                    <span v-if="totalVipCourseStudentCount > 0">VIP: {{totalVipCourseStudentCount}}人<br /></span>
                    <span v-if="totalRevieCoursewStudentCount > 0">复习课: {{totalRevieCoursewStudentCount}}人<br /></span>
                  </div>
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span class="cs-amount">{{ totalStudentCount }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中新生人数)
                <span class="cs-amount">{{
                  totalStudentCount - totalAuldStudentCount
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中老生人数)
                <span class="cs-amount">{{ totalAuldStudentCount }}</span>
              </div>
            </el-col>

            <el-col :lg="{ span: '4-6' }">
              <div>
                实时销售课次
                <span class="cs-amount">{{ totalSaleCount }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中复习课销售课次)
                <span class="cs-amount">{{
                  totalSaleReviewCourseCount
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中非复习课销售课次)
                <span class="cs-amount">{{ totalSaleCount - totalSaleReviewCourseCount }}</span>
              </div>
            </el-col>

            <el-col :lg="{ span: '4-6' }">
              <div>
                实时真实课次
                <span class="cs-amount">{{ totalCount }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中复习课真实课次)
                <span class="cs-amount">{{
                  totalIncomeReviewCourseCount
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中非复习课真实课次)
                <span class="cs-amount">{{ totalCount-totalIncomeReviewCourseCount }}</span>
              </div>
            </el-col>

            <el-col :lg="{ span: '4-6' }" v-if="courseType == GLOBAL.courseType.university">
              <div>
                实时连报率
                <span class="cs-amount">{{
                  getRate(totalCount, totalStudentCount)
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中新生销售连报率)
                <span class="cs-amount">{{
                  getRate(
                    totalSaleCount - totalAuldSaleCount,
                    totalStudentCount - totalAuldStudentCount
                  )
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中老生销售连报率)
                <span class="cs-amount">{{
                  getRate(totalAuldSaleCount, totalAuldStudentCount)
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中新生真实连报率)
                <span class="cs-amount">{{
                  getRate(
                    totalCount - totalAuldCount,
                    totalStudentCount - totalAuldStudentCount
                  )
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中老生真实连报率)
                <span class="cs-amount">{{
                  getRate(totalAuldCount, totalAuldStudentCount)
                }}</span>
              </div>
            </el-col>

            <el-col :lg="{ span: '4-6' }" v-if="courseType == GLOBAL.courseType.vocationalTraining">
              <div class="cs-saleQuery-summary-item">
                <span class="cs-saleQuery-summary-label">
                  看视频
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount">(应收){{
                    totalVideoAppointmentAmout | toCurrency
                  }}</span>
                  <span class="cs-amount">(收入){{
                    totalVideoAppointmentIncome | toCurrency
                  }}</span>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :lg="{ span: '4-8' }">
              <div class="cs-saleQuery-summary-item" v-if="courseType === GLOBAL.courseType.university">
                <span class="cs-saleQuery-summary-label">
                  视频包
                  <!-- <el-tooltip class="item" effect="dark" content="" placement="top">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </el-tooltip> -->
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount">(应收){{
                    totalVideoPackageAmount | toCurrency
                  }}</span>
                  <span class="cs-amount">(收入){{
                    totalVideoPackageIncome | toCurrency
                  }}</span>
                </div>
              </div>
            </el-col>

            <el-col :lg="{ span: '4-8' }">
              <div class="cs-saleQuery-summary-item" v-if="courseType === GLOBAL.courseType.university">
                <span class="cs-saleQuery-summary-label">
                  看视频
                </span>
                <div class="cs-saleQuery-summary-amount">
                  <span class="cs-amount">(应收){{
                    totalVideoAppointmentAmout | toCurrency
                  }}</span>
                  <span class="cs-amount">(收入){{
                    totalVideoAppointmentIncome | toCurrency
                  }}</span>
                </div>
              </div>
            </el-col>

            <el-col :lg="{ span: '4-8' }" v-if="courseType == GLOBAL.courseType.university">
              <div>
                总占位消耗率
                <el-tooltip v-if="totalAdvanceEnrollmentCount > 0" class="item" effect="dark" placement="top">
                  <div slot="content">
                    <span>报名课数: {{totalAdvanceEnrollmentCourseCount}}<br /></span>
                    <span>占位使用数: {{totalAdvanceEnrollmentCount}}<br /></span>
                  </div>
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span
                  class="cs-amount">{{ totalAdvanceEnrollmentCount > 0 ? (totalAdvanceEnrollmentCourseCount/totalAdvanceEnrollmentCount).toFixed(2) : 0 }}</span>
              </div>
              <div>
                新生占位消耗率
                <el-tooltip v-if="totalAdvanceEnrollmentCount - totalAuldAdvanceEnrollmentCount > 0" class="item" effect="dark" placement="top">
                  <div slot="content">
                    <span>新生报名课数: {{totalAdvanceEnrollmentCourseCount - totalAuldAdvanceEnrollmentCourseCount}}<br /></span>
                    <span>新生占位使用数: {{totalAdvanceEnrollmentCount - totalAuldAdvanceEnrollmentCount}}<br /></span>
                  </div>
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span
                  class="cs-amount">{{ totalAdvanceEnrollmentCount - totalAuldAdvanceEnrollmentCount > 0 ? ((totalAdvanceEnrollmentCourseCount - totalAuldAdvanceEnrollmentCourseCount)/(totalAdvanceEnrollmentCount - totalAuldAdvanceEnrollmentCount)).toFixed(2) : 0 }}</span>
              </div>
              <div>
                老生占位消耗率
                <el-tooltip v-if="totalAuldAdvanceEnrollmentCount > 0" class="item" effect="dark" placement="top">
                  <div slot="content">
                    <span>老生报名课数: {{totalAuldAdvanceEnrollmentCourseCount}}<br /></span>
                    <span>老生占位使用数: {{totalAuldAdvanceEnrollmentCount}}<br /></span>
                  </div>
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span
                  class="cs-amount">{{ totalAuldAdvanceEnrollmentCount > 0 ? (totalAuldAdvanceEnrollmentCourseCount/totalAuldAdvanceEnrollmentCount).toFixed(2) : 0 }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :lg="{ span: '4-8' }">
              <div>
                实时欠款
                <span class="cs-amount">{{ totalDebt | toCurrency }}</span>
              </div>
              <div>
                实时退余额总值
                <el-tooltip class="item" effect="dark" content="退在订单起始日" placement="top">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span class="cs-amount">{{
                  totalSaleRefundAmount | toCurrency
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中真实退余额)
                <span class="cs-amount">{{
                  totalRefundBalance | toCurrency
                }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中退积分)
                <span class="cs-amount">{{ totalRefundBonusPoint }}</span>
              </div>
              <div class="cs-saleQuery-summary-detail">
                (其中退款课程产生收入)
                <span class="cs-amount">{{
                  totalRefundIncomeAmount | toCurrency
                }}</span>
              </div>
            </el-col>
            <el-col :lg="{ span: '4-8' }">
              <div>
                实时使用余额
                <el-tooltip class="item" effect="dark" content="不含退款课程，不含赠送余额" placement="top">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span class="cs-amount">{{
                  totalBalanceCost + totalVideoAppointmentBalanceCost | toCurrency
                }}</span>
              </div>
              <div>
                实时使用积分
                <el-tooltip class="item" effect="dark" content="不含退款课程" placement="top">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span class="cs-amount">{{ totalBonusPointCost + totalVideoAppointmentBonusPointCost}}</span>
              </div>
              <div>
                实时使用赠送余额
                <el-tooltip class="item" effect="dark" content="不含退款课程" placement="top">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span class="cs-amount">{{
                  totalGiftBalanceCost + totalVideoAppointmentGiftBalanceCost | toCurrency
                }}</span>
              </div>

            </el-col>
            <el-col :lg="{ span: '4-8' }">
              <div v-if="USERMANAGER.isAdmin">
                总税费
                <el-tooltip class="item" effect="dark" content="不含退税" placement="top">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                <span class="cs-amount">{{
                  totalTax | toCurrency
                }}</span>
              </div>
              <div v-if="USERMANAGER.isAdmin">
                总退税
                <span class="cs-amount">{{
                  totalRefundTax | toCurrency
                }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row class="grid-content" v-if="canViewList">
          <el-col>
            <pagination v-loading="loading" :data="listData" :option="paginationOption" @search="search" @edit="refundToBanlance" @loadData="search"
              @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange" @videoPackageClick="onVideoPackageClicked"
              @joinWeChatGroupValidateClick="onJoinWeChatGroupValidateClicked" @changeCourseClick="onChangeCourseClicked" @cellDbClick="onCellDbClick">
            </pagination>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog :center="true" title="进群验证" :close-on-click-modal="false" width="800px" :visible.sync="joinWeChatGroupValidateDialogVisible" top="3vh">
      <el-row>
        <joinWechatgroupValidator :isDialog="true" align="center" :showPhone="false" :dataIn="joinWeChatGroupValidateDataIn"
          @validateSuccess="onValidateSuccess"></joinWechatgroupValidator>
      </el-row>
    </el-dialog>
    <el-dialog :center="true" title="退款" :close-on-click-modal="false" width="800px" :visible.sync="refundDialogVisible" top="3vh">
      <el-row>
        <refund-editor :dataIn="refundEditorDataIn" @closeRefundEditor="onCloseRefundEditor"></refund-editor>
      </el-row>
    </el-dialog>
    <el-dialog :center="true" title="退视频包" :close-on-click-modal="false" width="800px" :visible.sync="otherCollectFeeRefundDialogVisible" top="3vh">
      <el-row>
        <otherCollectFeeRefundEditor :dataIn="otherCollectFeeRefundEditorDataIn" @closeRefundEditor="onCloseOtherCollectFeeRefundEditor" />
      </el-row>
    </el-dialog>
    <el-dialog :center="true" title="换课" :close-on-click-modal="false" width="800px" :visible.sync="changeCourseDialogVisible" top="3vh">
      <el-row>
        <changeCourseEditor :dataIn="changeCourseDataIn" :courseType="courseType" @saveCourseChangeSuccess="onSaveCourseChangeSuccess"
          @closeChangeCourseEditor="onCloseChangeCourseEditor">
        </changeCourseEditor>
      </el-row>
    </el-dialog>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="englishEnsureScoreEditorVisible" top="3vh">
      <englishEnsureScoreEditor :dataIn="englishEnsureScoreData" @closeDialog="onEnglishEnsureScoreEditorClose" @saveSuccess="onEnglishEnsureScoreEditorSave">
      </englishEnsureScoreEditor>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.el-col-lg-4-8 {
  width: 33%;
}
.el-col-lg-4-6 {
  width: 22%;
}
body .cs-filter-row {
  padding-top: 10px;
}
.cs-totalAmount {
  font-size: 18px;
  font-weight: bold;
}

.cs-saleQuery-summary-item {
  margin-bottom: 8px;
  .cs-saleQuery-summary-label {
    display: inline-block;
    vertical-align: middle;
  }
  .cs-saleQuery-summary-amount {
    display: inline-block;
    vertical-align: middle;

    .cs-amount {
      display: block;

      &:nth-of-type(2) {
        border-top: 1px solid #b5b5b5;
      }
    }
  }
}

.cs-recordCount {
  color: gray;
  margin-left: 10px;
}

.cs-datepick-col {
  .cs-accountList-searchDate {
    margin-left: 20px;
    width: 250px !important;
    max-width: calc(100% - 20px);

    .el-range-separator {
      z-index: 99;
    }
  }
}
.cs-saleQuery-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  padding-left: 10px;

  .el-button {
    margin: 0;
    padding-left: 12px;
    padding-right: 12px;
  }
}
.cs-saleQuery-summary {
  font-size: 16px;
  i {
    color: #409eff;
    vertical-align: middle;
  }

  .cs-saleQuery-summary-detail {
    font-size: 11px;
    line-height: 16px;
    .cs-amount {
      font-size: 13px;
    }
  }
}
</style>

<script>
import pagination from "../common/pagination";
import refundEditor from "../common/refundEditor";
import otherCollectFeeRefundEditor from "../common/otherCollectFeeRefundEditor";
import changeCourseEditor from "../common/changeCourseEditor";
import { addMonth, formatDate, toDecimal, downloadFile } from "../../config/mUtils.js";
import {
  getUniversityGroups,
  getTerms,
  getTrainingTerms,
  getCourseCodeList,
  getAllTerchers,
  getAllTrainingTeacher,
  getAllCourseCategoryList,
  getTrainingCategoryList,
  getCourseClassGradeList,
} from "../../service/common.service";
import { getContractViewModelList } from "@/service/contract.service.js";
import { getTrainingCourses } from "../../service/speedupCourse.service.js";
import {
  getSalesQueryList,
  getSalesQuerySummary,
  exportSaleQueryCourses,
  exportSaleQueryCourseAveragePrice
} from "../../service/finance.service.js";
import {
  getEnglishEnsureScore,
  saveEnglishEnsureScore,
  changeWeChatGroupType,
} from "../../service/enrollmentFee.service";
import englishEnsureScoreEditor from "../addCollectFees/courseEnrollmentFee/englishEnsureScoreEditor";
import joinWechatgroupValidator from "@/components/common/JoinWeChatGroupValidator";
import global_ from "@/core/global";
import { getVipCoursePrices } from "@/service/globalPriceSetting.service";
import { getEmployees } from "../../service/user.service";

export default {
  props: {
    isActive: Boolean,
    courseType: Number,
    courseTypeText: String,
    isInternationalSales: Boolean,
    queryData: {
      studentName: String,
      termId: Number,
      courseType: Number,
    },
  },
  data() {
    return {
      canViewList: !this.USERMANAGER.isAcademicDirector,
      isManager: this.USERMANAGER.isManager || this.USERMANAGER.isAdmin,
      refundEditorDataIn: {
        workflowId: -1,
        workflowCourseId: -1,
        refundHistoryId: -1,
      },
      otherCollectFeeRefundEditorDataIn: {
        workflowId: -1
      },
      changeCourseDataIn: {
        salesQueryRow: Object,
      },
      joinWeChatGroupValidateDataIn: {
        salesQueryRow: Object,
        phone: "",
      },
      refundDialogVisible: false,
      otherCollectFeeRefundDialogVisible: false,
      changeCourseDialogVisible: false,
      joinWeChatGroupValidateDialogVisible: false,
      employeeListData: [],
      allContractList: [],
      contractList: [],
      teacherList: [],
      courseCategoryList: [],
      categoryList: [],
      courseClassGradeList: [],
      vipCoursePrices: [],
      selectedAccountStatus: 0,
      currentTermId: 0,
      totalSaleIncome: 0,
      totalIncome: 0,
      totalCount: 0,
      totalPaymentDiscount: 0,
      totalStudentCount: 0,
      totalDebt: 0,
      totalBonusPointCost: 0,
      totalBalanceCost: 0,
      totalBalanceCostTax: 0,
      totalRefundAmount: 0,
      totalRefundBalance: 0,
      totalRefundBonusPoint: 0,
      totalSaleRefundAmount: 0,
      totalRefundIncomeAmount: 0,
      totalSaleCount: 0,
      totalAuldCount: 0,
      totalAuldSaleCount: 0,
      totalAuldStudentCount: 0,
      totalSaleReviewCourseCount: 0,
      totalIncomeReviewCourseCount: 0,
      totalGiftBalanceCost: 0,
      totalTax: 0,
      totalRefundTax: 0,
      studentCourseCountData: [],
      totalVipCourseStudentCount: 0,
      totalRevieCoursewStudentCount: 0,
      totalAuldAdvanceEnrollmentCourseCount: 0,
      totalAuldAdvanceEnrollmentCount: 0,
      totalAdvanceEnrollmentCourseCount: 0,
      totalAdvanceEnrollmentCount: 0,
      totalVideoPackageAmount: 0,
      totalVideoPackageIncome: 0,
      totalVideoAppointmentBonusPointCost: 0,
      totalVideoAppointmentBonusPointPrice: 0,
      totalVideoAppointmentOldBalanceCost: 0,
      totalVideoAppointmentNewBalanceCost: 0,
      totalVideoAppointmentGiftBalanceCost: 0,
      totalVideoAppointmentAmout: 0,
      totalVideoAppointmentIncome: 0,
      totalVideoAppointmentBalanceCost: 0,
      totalVIPIncome: 0,
      TotalVIPIncomeTax: 0,
      totalVIPPaymentDiscount: 0,
      totalVIPTax: 0,
      totalVIPRefundTax: 0,
      totalVIPRefundAmount: 0,
      totalVIPBalanceCost: 0,
      totalVIPBalanceCostTax: 0,

      //总实时价值收入
      totalViewIncome:0,
      totalViewIncomeWithTax:0,
      totalViewVipIncome:0,
      totalViewVipIncomeWithTax:0,
      //总实时销售收入
      totalViewSaleIncome: 0,
      totalViewSaleIncomeWithTax: 0,
      totalViewVipSaleIncome: 0,
      totalViewVipSaleIncomeWithTax: 0,
      //总实时真实收入
      totalViewRealIncome: 0,
      totalViewRealIncomeWithTax: 0,
      totalViewVipRealIncome: 0,
      totalViewVipRealIncomeWithTax: 0,
      //总实时真实入库学费
      totalViewStorageIncome: 0,
      totalViewStorageIncomeWithTax: 0,
      totalViewVipStorageIncome: 0,
      totalViewVipStorageIncomeWithTax: 0,
      
      totalVipUsedAmount: 0,
      totalVipUsedAmountTax: 0,
      totalVIPUnused:0,
      totalVIPUnusedWithTax:0,

      totalViewNotVipRealIncomeWithTax: 0,
      totalViewNotVipRealIncome: 0,

      isLoadingSaleSummary: false,
      isExporting: false,
      isExportingAvgPrice: false,
      termList: [],
      courseCodeList: [],
      trainingCourseList: [],
      studentTypes:[
        {
          Key: 0,
          Value: "所有(新生)",
        },
        {
          Key: 1,
          Value: "新生"
        },
        {
          Key: 2,
          Value: "老生"
        }
      ],
      searchType: [
        {
          Key: 1,
          Value: "按日期",
        },
        {
          Key: 2,
          Value: "按学期",
        },
        {
          Key: 3,
          Value: "学期和日期",
        },
      ],
      accountStatusList: [
        {
          Key: -1,
          Value: "所有(状态)",
        },
        {
          Key: 0,
          Value: "标红",
        },
        {
          Key: 1,
          Value: "正常",
        },
      ],
      refundStatusList: [
        {
          Key: 0,
          Value: "所有(退课)",
        },
        {
          Key: 1,
          Value: "有退课",
        },
        {
          Key: 2,
          Value: "无退课",
        },
      ],
      isStudyAbroadConditionOptions: [
        {
          Key: 0,
          Value: "所有(真留)",
        },
        {
          Key: 1,
          Value: "非真留",
        },
        {
          Key: 2,
          Value: "真留",
        },
      ],
      hasVideoPackageOptions: [
        {
          Key: 0,
          Value: "所有(视频包)",
        },
        {
          Key: 1,
          Value: "已购买视频包",
        },
        {
          Key: 2,
          Value: "未购买视频包",
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      paginationOption: {},
      universityGroups: [],
      searchDate: "",
      searchPhone: "",
      selectedGroupNumber: "",
      selectedSearchType: 1,
      selectedTermId: "",
      selectedContractId: -1,
      selectedCourseCode: "",
      selectedTeacherId: "",
      selectedUserId: "",
      selectedCourseId: 0,
      selectedCategory: 0,
      selectedRefundStatus: 0,
      selectedCourseClassGrade: "",
      selectedCourseCategoryIds: [0],
      selectedStudentType: 0,
      isStudyAbroad: 0,
      hasVideoPackage: 0,
      studyAbroadBusinessType: 0,
      loading: false,
      listData: [],
      pageSize: 20,
      englishEnsureScoreData: {},
      englishEnsureScoreEditorVisible: false,
      isLoadedData: false,
      isInit: false,
      canViewTax: false,
      canExport: false,
      canExportAveragePrice: false,
      hasEmployeeFilter: false,
      hasSaleSummary: true
    };
  },
  components: {
    navigator,
    pagination,
    refundEditor,
    otherCollectFeeRefundEditor,
    changeCourseEditor,
    englishEnsureScoreEditor,
    joinWechatgroupValidator,
  },
  created() {
    this.canViewTax =
      this.USERMANAGER.isAdmin ||
      this.USERMANAGER.isRegionCEO ||
      this.USERMANAGER.isCampusPresident ||
      this.USERMANAGER.isFinancialManager;
    this.canExport = this.USERMANAGER.isAdmin;
    this.canExportAveragePrice = this.USERMANAGER.isAdmin
      || this.USERMANAGER.isAcademicDirector
      || this.USERMANAGER.isPersonnelManagement;
    this.hasSaleSummary = !this.USERMANAGER.isAssistant;
    if (this.USERMANAGER.isFrontDesk || this.USERMANAGER.isFinancialAssistant) {
      this.selectedAccountStatus = 0;
    } else {
      this.selectedAccountStatus = -1;
    }

    this.hasEmployeeFilter = (this.USERMANAGER.isAdmin || this.USERMANAGER.isRegionCEO || 
      this.USERMANAGER.isCampusPresident || this.USERMANAGER.isFinancialManager)
      && (this.courseType == this.GLOBAL.courseType.university || this.courseType == this.GLOBAL.courseType.vocationalTraining); 
    if (this.hasEmployeeFilter){
      this.getEmployeeListData();
    }

    this.paginationOption = {
      displayPagination: true,
      hasEditButton: this.isManager,
      editButtonText: "退款",
      hasAddButton: false,
      hasSearch: false,
      hasDateSearch: false,
      hasVideoPackageButton:
        (this.USERMANAGER.isFrontDesk || this.isManager) &&
        this.courseType == 1,
      hasJoinWeChatGroupValidateButton:
        this.USERMANAGER.isFrontDesk || this.isManager,
      hasChangeCourseButton:
        (this.USERMANAGER.isFrontDesk || this.isManager) &&
        this.courseType != 4,
      displayEnsureScore: this.courseType == this.GLOBAL.courseType.english,
      displayTermName: ![
        this.GLOBAL.courseType.english,
        this.GLOBAL.courseType.newStudentGuide,
      ].contains(this.courseType),
      fnRowEditVisible: this.checkRowEditVisible,
      displayTeacherPaymentPrice:
        (this.USERMANAGER.isAdmin || this.USERMANAGER.isFinancialManager) &&
        this.courseType !== 4,
    };
    this.searchDate = [];
    let today = new Date();
    //let lastMonthDate = addMonth(today, -1);
    //this.searchDate.push(lastMonthDate);
    this.searchDate.push(today);
    this.searchDate.push(today);
    getUniversityGroups().then((result) => {
      if (!!result && result.success) {
        this.universityGroups = result.data;
        this.universityGroups.splice(0, 0, {
          GroupNumber: -1,
          NameValue: "不限大学",
        });
      }
      this.selectedGroupNumber = -1;
    });

    getAllCourseCategoryList().then((result) => {
      if (!!result && result.success) {
        this.courseCategoryList = result.data;
      }
    });

    if (
      [
        this.GLOBAL.courseType.english,
        this.GLOBAL.courseType.vocationalTraining,
        this.GLOBAL.courseType.newStudentGuide,
      ].contains(this.courseType)
    ) {
      getAllTrainingTeacher(this.courseType).then((result) => {
        if (!!result && result.success) {
          this.teacherList = result.data;
          this.teacherList.splice(0, 0, {
            Key: -1,
            Value: "所有老师",
          });
          this.selectedTeacherId = -1;
        }
      });

      getTrainingCategoryList(this.courseType).then((result) => {
        if (!!result && result.success) {
          this.categoryList = result.data;
          this.categoryList.splice(0, 0, {
            Id: 0,
            Name: "所有业务",
          });
        }
      });

      this.trainingCourseList = [
        {
          Id: 0,
          Name: "所有课程",
        },
      ];
    } else {
      getVipCoursePrices().then((result) => {
        if (!!result && result.success) {
          this.vipCoursePrices = result.data;
        }
      });
      getCourseClassGradeList().then((result) => {
        if (!!result && result.success) {
          this.courseClassGradeList = result.data;
          this.courseClassGradeList.splice(0, 0, {
            Key: 0,
            Value: "所有课程年级",
          });
          this.selectedCourseClassGrade = 0;
        }
      });

      getAllTerchers().then((result) => {
        if (!!result && result.success) {
          this.teacherList = result.data;
          this.teacherList.splice(0, 0, {
            Key: -1,
            Value: "所有老师",
          });
          this.selectedTeacherId = -1;
        }
      });
      this.loadUniversityCourseList();
      this.getTermsByCourseType();
    }

    this.loadContractList();
    this.init();
  },
  methods: {
    init() {
      this.isInit = true;
      if (!!this.queryData && this.queryData.courseType == this.courseType) {
        this.searchPhone = this.queryData.studentName;
        this.selectedSearchType = 2;
        this.selectedTermId = this.queryData.termId;
        this.selectedAccountStatus = -1;
        this.search();
      } else {
        this.search();
      }
    },
    checkRowEditVisible(index, row) {
      return row.IsShowRefundButton;
    },
    loadUniversityCourseList(callback) {
      this.selectedCourseCode = "";
      let termId = this.selectedTermId;
      if (this.selectedSearchType == 1) {
        termId = "";
      }
      getCourseCodeList(this.selectedGroupNumber, termId).then((result) => {
        if (!!result && result.success) {
          this.courseCodeList = result.data;
          this.courseCodeList.splice(0, 0, {
            Key: "",
            Value: "所有课程",
          });

          if (!!callback) {
            callback();
          }
        }
      });
    },
    onCellDbClick(data) {
      if (data.column.columnKey == "EnsureScore") {
        let id = data.row.WorkflowId;
        if (!!id) {
          getEnglishEnsureScore(id).then((result) => {
            if (result.success) {
              this.englishEnsureScoreData = result.data;
              this.englishEnsureScoreEditorVisible = true;
            }
          });
        }
      }
    },
    onEnglishEnsureScoreEditorClose() {
      this.englishEnsureScoreEditorVisible = false;
    },
    onEnglishEnsureScoreEditorSave() {
      this.search();
    },
    loadCourseList(callback) {
      if (
        (!this.selectedTermId &&
          this.courseType == this.GLOBAL.courseType.vocationalTraining) ||
        !this.selectedCategory
      ) {
        this.selectedCourseId = 0;
        this.trainingCourseList = [
          {
            Id: 0,
            Name: "所有课程",
          },
        ];
        if (callback) {
          callback();
        }
        return;
      }
      getTrainingCourses(this.selectedTermId, this.selectedCategory).then(
        (result) => {
          if (!!result && result.success) {
            this.selectedCourseId = 0;
            this.trainingCourseList = result.data;
            this.trainingCourseList.splice(0, 0, {
              Id: 0,
              Name: "所有课程",
            });
            if (callback) {
              callback();
            }
          }
        }
      );
    },
    getTermsByCourseType(callback) {
      if (
        [
          this.GLOBAL.courseType.english,
          this.GLOBAL.courseType.newStudentGuide,
        ].contains(this.courseType)
      ) {
        if (callback) {
          callback();
        }
      } else if (this.courseType == this.GLOBAL.courseType.university) {
        getTerms(true).then((result) => {
          if (!!result && result.success) {
            this.termList = result.data;
            let currentTerm = result.data.filter((i) => i.IsCurrentTerm);
            if (currentTerm && currentTerm.length > 0) {
              this.currentTermId = currentTerm[0].Id;
              this.selectedTermId = this.currentTermId;
            }
          }
        });
      } else if (this.courseType == this.GLOBAL.courseType.vocationalTraining) {
        if (!this.selectedCategory) {
          //this.$message.warning("请先选择业务");
          if (callback) {
            callback();
          }
          return;
        }
        getTrainingTerms(true, this.selectedCategory).then((result) => {
          if (!!result && result.success) {
            this.termList = result.data;
            let currentTerm = result.data.filter((i) => i.IsCurrentTerm);
            if (currentTerm && currentTerm.length > 0) {
              this.currentTermId = currentTerm[0].Id;
              this.selectedTermId = this.currentTermId;
              if (callback) {
                callback();
              }
            }
          }
        });
      }
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    onTabClicked() {
      //this.search();
    },
    onCategoryChange() {
      this.getTermsByCourseType(() => {
        this.loadCourseList(() => {
          //this.search();
        });
      });
    },
    onTermChange() {
      this.loadContractListInTerm(this.selectedTermId == this.currentTermId);
      if (this.courseType == this.GLOBAL.courseType.university) {
        this.loadUniversityCourseList(() => {
          //this.search();
        });
      } else {
        this.loadCourseList(() => {
          //this.search();
        });
      }
    },
    async onExport(){
      this.isExporting = true;
      try {
        let pageData = this.getSearchPageData();
        let result = await exportSaleQueryCourses(pageData);
        if (!!result && result.success) {
          downloadFile(result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },
    async onExportAveragePrice(){
      this.isExportingAvgPrice = true;
      try {
        let pageData = this.getSearchPageData();
        let result = await exportSaleQueryCourseAveragePrice(pageData);
        if (!!result && result.success) {
          downloadFile(result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isExportingAvgPrice = false;
      }
    },
    onCourseCategoryIdsChanged(values) {
      const allValue = 0;
      if (!values || values.length === 0 || values[values.length - 1] === allValue) {
        this.selectedCourseCategoryIds = [allValue];
      } else {
        this.selectedCourseCategoryIds = values.filter((value) => value !== allValue);
      }
      this.onSearchConditionChanged();
    },
    onSearchConditionChanged(name, isSearch) {
      if (
        name == "searchType" &&
        this.courseType == this.GLOBAL.courseType.university
      ) {
        this.loadUniversityCourseList(() => {
          if (isSearch) {
            this.search();
          }
        });
      } else if (
        name == "university" &&
        this.courseType == this.GLOBAL.courseType.university
      ) {
        this.loadUniversityCourseList(() => {
          if (isSearch) {
            this.search();
          }
        });
      } else {
        if (isSearch) {
          this.search();
        }
      }
    },
    search(pageData) {
      if (!this.isActive) {
        return;
      }
      let searchData = this.getSearchPageData(pageData);
      this.loadSalesQueryData(searchData);
      this.loadSalesSummaryData(searchData);
    },
    refundToBanlance(index, row) {
      let dataIn = {
        workflowId: row.WorkflowId,
        workflowCourseId: row.Id,
        refundHistoryId: row.RefundHistoryId,
      };

      this.refundEditorDataIn = dataIn;
      this.refundDialogVisible = true;
    },
    onVideoPackageClicked(index, row) {
      if (row.HasVideoPackage) {
        let dataIn = {
          workflowId: row.VideoPackageWorkflowId
        };

        this.otherCollectFeeRefundEditorDataIn = dataIn;
        this.otherCollectFeeRefundDialogVisible = true;
      } else {
        this.$router.push({
          path: "/addCollectFees/otherCollectFee",
          query: {
            type: this.GLOBAL.otherCollectFeeType.videoPackage.value,
            phone: row.Phone,
            courseId: row.CourseId,
          },
        });
      }
    },
    onJoinWeChatGroupValidateClicked(index, row) {
      let dataIn = {
        salesQueryRow: row,
        phone: row.PhoneFullNumber,
      };
      this.joinWeChatGroupValidateDataIn = dataIn;
      this.joinWeChatGroupValidateDialogVisible = true;
    },
    openChangeCourseForInit() {
      if (this.isInit) {
        if (
          !!this.queryData &&
          this.queryData.courseType == this.courseType &&
          !!this.queryData.studentId &&
          !!this.queryData.week &&
          !!this.queryData.supplementVideoType
        ) {
          let row = this.listData.Results.find(
            (i) =>
              i.StudentId == this.queryData.studentId &&
              i.CourseId == this.queryData.courseId &&
              i.IsRefund == 0
          );
          if (!!row) {
            this.openChangeCourse(
              row,
              this.queryData.week,
              this.queryData.supplementVideoType
            );
          }
        }
      }
    },
    onChangeCourseClicked(index, row) {
      this.openChangeCourse(row);
    },
    openChangeCourse(row, week, supplementVideoType) {
      if (!week) {
        week = -1;
      }
      if (!supplementVideoType) {
        supplementVideoType = -1;
      }
      let dataIn = {
        salesQueryRow: row,
        courseCategoryList: this.courseCategoryList,
        week: week,
        supplementVideoType: supplementVideoType,
        vipCoursePrices: this.vipCoursePrices,
      };
      this.changeCourseDataIn = dataIn;
      this.changeCourseDialogVisible = true;
    },
    onCloseRefundEditor(value) {
      let dataIn = {
        workflowId: -1,
        workflowCourseId: -1,
        refundHistoryId: -1,
      };
      this.refundEditorDataIn = dataIn;
      this.refundDialogVisible = false;
      if (value == "success") {
        this.search();
      }
    },
    onCloseOtherCollectFeeRefundEditor(value) {
      let dataIn = {
        workflowId: -1
      };
      this.otherCollectFeeRefundEditorDataIn = dataIn;
      this.otherCollectFeeRefundDialogVisible = false;
      if (value == "success") {
        this.search();
      }
    },
    onCloseChangeCourseEditor() {
      let dataIn = {
        salesQueryRow: {},
        courseCategoryList: this.courseCategoryList,
      };
      this.changeCourseDataIn = dataIn;
      this.changeCourseDialogVisible = false;
    },
    onSaveCourseChangeSuccess() {
      this.search();
      this.changeCourseDialogVisible = false;
    },
    async onValidateSuccess(dataOut) {
      let row = dataOut.row;

      let result = await changeWeChatGroupType(row.Id, 1);
      if (!result || !result.success) return;

      this.joinWeChatGroupValidateDialogVisible = false;
      this.search();
    },
    loadContractList() {
      let contractType = this.GLOBAL.contractType.getValueByCourseType(
        this.courseType
      );
      getContractViewModelList(false).then((result) => {
        if (!!result && result.success) {
          this.allContractList = result.data.filter(
            (i) => i.ContractType === contractType
          );
          this.loadContractListInTerm(true);
        }
      });
    },
    loadContractListInTerm(isCurrentTerm) {
      if (isCurrentTerm) {
        this.contractList = this.allContractList.filter((i) => i.Enable);
      } else {
        this.contractList = this.allContractList;
      }
    },
    loadSalesQueryData(pageData) {
      this.loading = true;
      this.isLoadedData = true;
      getSalesQueryList(pageData)
        .then((result) => {
          if (result && result.success) {
            this.listData = result.data;
            // this.totalIncome = this.listData.AdditionalResult.TotalIncome;
            // this.totalCount = this.listData.RecordCount;
            // this.totalDebt = this.listData.AdditionalResult.TotalDebt;
            // this.totalPaymentDiscount = this.listData.AdditionalResult.TotalPaymentDiscount;
            // this.totalBonusPointCost = this.listData.AdditionalResult.TotalBonusPointCost;
            // this.totalBalanceCost = this.listData.AdditionalResult.TotalBalanceCost;
            // this.totalRefundAmount = this.listData.AdditionalResult.TotalRefundAmount;
            // this.totalRefundBalance = this.listData.AdditionalResult.TotalRefundBalance;
            // this.totalRefundBonusPoint = this.listData.AdditionalResult.TotalRefundBonusPoint;
            this.openChangeCourseForInit();
          }
          this.loading = false;
          this.isInit = false;
        })
        .catch((error) => {
          this.loading = false;
          this.isInit = false;
        });
    },
    loadSalesSummaryData(pageData) {
      this.isLoadingSaleSummary = true;
      getSalesQuerySummary(pageData)
        .then((result) => {
          if (result && result.success) {
            this.totalSaleIncome = result.data.TotalSaleIncome;
            this.totalIncome = result.data.TotalIncome;
            this.totalDebt = result.data.TotalDebt;
            this.totalPaymentDiscount = result.data.TotalPaymentDiscount;
            this.totalStudentCount = result.data.TotalStudentCount;
            this.totalBonusPointCost = result.data.TotalBonusPointCost;
            this.totalBalanceCost = result.data.TotalBalanceCost;
            this.totalBalanceCostTax = result.data.TotalBalanceCostTax;
            this.totalRefundAmount = result.data.TotalRefundAmount;
            this.totalRefundBalance = result.data.TotalRefundBalance;
            this.totalRefundBonusPoint = result.data.TotalRefundBonusPoint;

            this.totalSaleRefundAmount = result.data.TotalSaleRefundAmount;
            this.totalRefundIncomeAmount = result.data.TotalRefundIncomeAmount;
            this.totalSaleCount = result.data.TotalSaleCount;
            this.totalCount = result.data.TotalCount;

            this.totalAuldCount = result.data.TotalAuldCount;
            this.totalAuldSaleCount = result.data.TotalAuldSaleCount;
            this.totalAuldStudentCount = result.data.TotalAuldStudentCount;
            this.totalSaleReviewCourseCount = result.data.TotalSaleReviewCourseCount;           
            this.totalIncomeReviewCourseCount = result.data.TotalIncomeReviewCourseCount;
            this.totalGiftBalanceCost = result.data.TotalGiftBalanceCost;
            this.totalTax = result.data.TotalTax;
            this.totalRefundTax = result.data.TotalRefundTax;

            this.totalVideoPackageAmount = result.data.TotalVideoPackageAmount;
            this.totalVideoPackageIncome = result.data.TotalVideoPackageIncome;

            this.totalVideoAppointmentBonusPointCost = result.data.TotalVideoAppointmentBonusPointCost;
            this.totalVideoAppointmentBonusPointPrice = result.data.TotalVideoAppointmentBonusPointPrice;
            this.totalVideoAppointmentOldBalanceCost = result.data.TotalVideoAppointmentOldBalanceCost;
            this.totalVideoAppointmentNewBalanceCost = result.data.TotalVideoAppointmentNewBalanceCost;
            this.totalVideoAppointmentGiftBalanceCost = result.data.TotalVideoAppointmentGiftBalanceCost;
            this.totalVideoAppointmentAmout = result.data.TotalVideoAppointmentAmout;
            this.totalVideoAppointmentIncome = result.data.TotalVideoAppointmentIncome;
            this.totalVideoAppointmentBalanceCost = this.totalVideoAppointmentOldBalanceCost + this.totalVideoAppointmentNewBalanceCost;

            this.totalAuldAdvanceEnrollmentCourseCount = result.data.TotalAuldAdvanceEnrollmentCourseCount;
            this.totalAuldAdvanceEnrollmentCount = result.data.TotalAuldAdvanceEnrollmentCount;
            this.totalAdvanceEnrollmentCourseCount = result.data.TotalAdvanceEnrollmentCourseCount;
            this.totalAdvanceEnrollmentCount = result.data.TotalAdvanceEnrollmentCount;

            this.totalVIPIncome = result.data.TotalVIPIncome;
            this.totalVIPIncomeTax = result.data.TotalVIPIncomeTax;
            this.totalVIPPaymentDiscount = result.data.TotalVIPPaymentDiscount;
            this.totalVIPTax = result.data.TotalVIPTax;
            this.totalVIPRefundTax = result.data.TotalVIPRefundTax;
            this.totalVIPRefundAmount = result.data.TotalVIPRefundAmount;
            this.totalVIPBalanceCost = result.data.TotalVIPBalanceCost;
            this.totalVIPBalanceCostTax = result.data.TotalVIPBalanceCostTax;
            this.totalVipUsedAmount = result.data.TotalVipUsedAmount;
            this.totalVipUsedAmountTax = result.data.TotalVipUsedAmountTax;

            let videoIncome = this.totalVideoPackageIncome + this.totalVideoAppointmentIncome;
            //总实时价值收入
            this.totalViewIncome = this.totalPaymentDiscount + this.totalVideoPackageAmount + this.totalVideoAppointmentAmout;
            this.totalViewIncomeWithTax = this.totalViewIncome + this.totalTax + this.totalRefundTax;
            this.totalViewVipIncome = this.totalVIPPaymentDiscount;
            this.totalViewVipIncomeWithTax = this.totalViewVipIncome + this.totalVIPTax + this.totalVIPRefundTax;
            //总实时销售收入
            this.totalViewSaleIncome = this.totalSaleIncome + videoIncome;
            this.totalViewSaleIncomeWithTax = this.totalViewSaleIncome + this.totalTax + this.totalRefundTax;
            this.totalViewVipSaleIncome = this.totalVIPIncome + this.totalVIPRefundAmount;
            this.totalViewVipSaleIncomeWithTax = this.totalViewVipSaleIncome + this.totalVIPTax + this.totalVIPRefundTax;
            //总实时真实收入
            this.totalViewRealIncome = this.totalIncome + videoIncome - this.totalVIPIncome + this.totalVipUsedAmount;
            this.totalViewRealIncomeWithTax = this.totalViewRealIncome + this.totalTax - this.totalVIPTax + this.totalVipUsedAmountTax;
            this.totalViewVipRealIncome = this.totalVipUsedAmount;
            this.totalViewVipRealIncomeWithTax = this.totalVipUsedAmount + this.totalVipUsedAmountTax;
            this.totalVIPUnused = this.totalVIPIncome - this.totalVipUsedAmount;
            this.totalVIPUnusedWithTax = this.totalVIPUnused + this.totalVIPIncomeTax - this.totalVipUsedAmountTax;
            this.totalViewNotVipRealIncomeWithTax = this.totalViewRealIncomeWithTax - this.totalViewVipRealIncomeWithTax;
            this.totalViewNotVipRealIncome = this.totalViewRealIncome - this.totalViewVipRealIncome;
            if (this.totalViewNotVipRealIncomeWithTax < 0){
              this.totalViewNotVipRealIncomeWithTax = 0;
            }
            if (this.totalViewNotVipRealIncome < 0){
              this.totalViewNotVipRealIncome = 0;
            }
            //总实时真实入库学费
            this.totalViewVipStorageIncome = this.totalVIPIncome - this.totalVIPBalanceCost;
            this.totalViewVipStorageIncomeWithTax = this.totalViewVipStorageIncome + this.totalVIPTax - this.totalVIPBalanceCostTax;
            let totalStorageIncome = this.totalIncome - this.totalBalanceCost + videoIncome;
            this.totalViewStorageIncome = totalStorageIncome - this.totalViewVipStorageIncome + this.totalViewVipRealIncome;
            this.totalViewStorageIncomeWithTax = totalStorageIncome + this.totalTax - this.totalBalanceCostTax 
              - this.totalViewVipStorageIncomeWithTax + this.totalViewVipRealIncomeWithTax;
                
            this.studentCourseCountData = result.data.StudentCourseCountData.filter((i) => i.Category == 1);
            let vipStudentCourseCountData = result.data.StudentCourseCountData.filter((i) => i.Category == 2);
            let reviewStudentCourseCountData = result.data.StudentCourseCountData.filter((i) => i.Category == 3);
            if (vipStudentCourseCountData.length > 0) {
              this.totalVipCourseStudentCount = vipStudentCourseCountData
                .map((x) => x.StudentCount)
                .reduce((n, m) => n + m);
            } else {
              this.totalVipCourseStudentCount = 0;
            }
            if (reviewStudentCourseCountData.length > 0) {
              this.totalRevieCoursewStudentCount = reviewStudentCourseCountData
                .map((x) => x.StudentCount)
                .reduce((n, m) => n + m);
            } else {
              this.totalRevieCoursewStudentCount = 0;
            }
          }
          this.isLoadingSaleSummary = false;
        })
        .catch((error) => {
          this.isLoadingSaleSummary = false;
        });
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageData) {
      if (typeof pageData == "undefined" || pageData == 1) {
        pageData = {
          pageNumber: 1,
        };
      }
      let startDate = "";
      let endDate = "";
      if (
        !!this.searchDate &&
        this.searchDate.length == 2 &&
        this.selectedSearchType != 2
      ) {
        startDate = formatDate(this.searchDate[0]);
        endDate = formatDate(this.searchDate[1]);
      }

      let additionalFilter = {
        GroupNumber:
          this.selectedGroupNumber == "" ? -1 : this.selectedGroupNumber,
        SearchType: this.selectedSearchType,
        TermId: this.selectedTermId,
        IsTermRange:
          this.selectedSearchType == 2 || this.selectedSearchType == 3 ? 1 : 0,
        ContractId: this.selectedContractId,
        CourseCode: this.selectedCourseCode,
        TeacherId: this.selectedTeacherId,
        AccountStatus: this.selectedAccountStatus,
        IsFrontDesk: this.USERMANAGER.isFrontDesk,
        CourseType: this.courseType,
        CategoryId: this.selectedCategory,
        UserId: this.selectedUserId,
        CourseId: this.selectedCourseId,
        RefundStatus: this.selectedRefundStatus,
        CourseClassGrade: this.selectedCourseClassGrade,
        CourseCategoryIds: this.selectedCourseCategoryIds.filter((id) => id > 0),
        StudyAbroadBusinessType: this.studyAbroadBusinessType,
        IsStudyAbroad: this.isStudyAbroad,
        HasVideoPackage: this.hasVideoPackage,
        IsInternationalSales: this.isInternationalSales,
        StudentType: this.selectedStudentType,
      };
      let searchData = {
        pageSize: this.pageSize,
        keyWord: this.searchPhone,
        startDate: startDate,
        endDate: endDate,
        additionalFilter: additionalFilter,
      };
      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },
    getRate(courseCount, studentCount) {
      if (studentCount > 0) {
        return toDecimal(courseCount / studentCount);
      } else {
        return 0;
      }
    },
    async getEmployeeListData() {
      let list = [];
      if (this.USERMANAGER.isAdmin){
        list = this.GLOBAL.roleType.getOptionsByKeys([
          "sales",
          "receptionist",
          "executiveManager",
          "financialManager",
          "regionCEO",
          "campusPresident",
        ]);
      }else{
        list = this.GLOBAL.roleType.getOptionsByKeys([
          "sales",
          "receptionist",
        ]);
      }
      let roleTypes = list.map(enumOption => enumOption.value);
      let result = await getEmployees(roleTypes, "", null, true);
      if (result && result.success) {
        this.employeeListData = result.data.Results.map(i => {
          return { Id: i.UserId, Name: i.Name };
        });
        this.employeeListData.splice(0, 0, { Id: 0, Name: "所有行政人员" });
      } else {
        this.employeeListData = [];
        this.employeeListData.push({ Id: 0, Name: "所有行政人员" });
      }
      this.selectedUserId = 0;
    },
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.search();
      }
    },
    queryData: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/salesQuery/salesQueryList.vue